import { useEffect, useState } from 'react'
import { Option } from '../../../../../config/types/component'
import Currency from '../../../../../models/Currency'
import { get } from '../../../../../utilities/http'

export default function useCompanyCurrencies(optionCompany: Option) {
    const [currencies, setCurrencies] = useState<Currency[]>([])

    useEffect(() => {
        if (!optionCompany || optionCompany.value === '0') {
            setCurrencies([])
            return
        }
        get<Currency[]>(
            `/v5.6/core/currencies?company_id=${optionCompany.value}`
        ).then(({ data, error }) => {
            if (!error) setCurrencies(data.result)
        })
    }, [optionCompany])

    return currencies
}
